/**
 * ThemeBadge is the gift theme selection button. It has three main uses/states:
 * the user has selected a theme (in /send or /gift), then is shows the selected theme as bg and shows gift icon
 */

import PropTypes from 'prop-types'

import React from 'react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import { getThemeImage } from '../../utils/theme-utils'
import * as media from '../../../lib/styles/media-queries'
import content from 'pp-react-l10n'

let i18n = content('transfer/themes')
const styles = StyleSheet.create({
  themeWrapper: {
    width: 120,
    height: 170,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.24)',
    outline: 'none',
    marginLeft: 135,
    display: 'block',
    ':hover': {
      cursor: 'default',
    },
    [media.smallAndSmaller]: {
      marginLeft: 105,
    },
  },
  badgeWrapper: {
    height: 220,
  },
  themeButton: {
    display: 'inline',
    padding: '15px 0px',
    fontWeight: 500,
    fontSize: 14,
    color: '#0070BA',
  },
})

class NewThemeBadge extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func,
    selectedThemeId: PropTypes.string,
    handleRemoveButton: PropTypes.func,
  }

  static defaultProps = {
    handleClick: () => {},
    selectedThemeId: '',
  }

  render() {
    const { handleClick, selectedThemeId, handleRemoveButton } = this.props

    const bgImage = getThemeImage(selectedThemeId, 'card')

    return (
      <div className={css(styles.badgeWrapper)}>
        <button
          type="button"
          style={{ background: `url(${bgImage})` }}
          className={css(styles.themeWrapper)}
        />
        <button
          onClick={handleClick}
          type="button"
          className={`${css(styles.themeButton)} vx_btn-link`}
        >
          {i18n('selection.changeDesign')}
        </button>
        <span className={css(styles.themeButton)}> | </span>
        <button
          onClick={handleRemoveButton}
          type="button"
          className={`${css(styles.themeButton)} vx_btn-link`}
        >
          {i18n('selection.removeDesign')}
        </button>
      </div>
    )
  }
}

export default NewThemeBadge
